import { useLang } from 'hooks/lang';

import { DropdownMenuItem, Button, overlayEscape, Row, ResponsiveRender } from 'components/Blocks';

import { useTaskOption } from './options';
import { TaskOption } from './createTaskOptions';

import { cn } from 'styles';
import { useKeyPressV2 } from 'hooks';

interface Props {
  option: TaskOption;
  className?: string;
  taskId: string;
}

export function TaskOptionItem({ option, className, taskId }: Props) {
  const { t } = useLang();
  const { Icon, action, getLabel, isEnabled, shortcutKey } = useTaskOption(option, taskId);

  useKeyPressV2({
    key: shortcutKey || '',
    isEnabled,
    action: () => {
      action();
      overlayEscape();
    },
  });

  if (!isEnabled) return null;

  return (
    <ResponsiveRender
      defaultContent={
        <DropdownMenuItem onClick={action} className={className} shortCut={shortcutKey}>
          {typeof Icon === 'function' ? <Icon /> : Icon}

          {getLabel?.(t)}
        </DropdownMenuItem>
      }
      responsiveContent={
        <Button
          size="small"
          variant="ghost"
          color="gray"
          className={cn(className, 'shrink-0')}
          onClick={() => {
            action();
            overlayEscape();
          }}
        >
          <Row fullWidth justifyContent="flex-start">
            {typeof Icon === 'function' ? <Icon /> : Icon}

            {getLabel?.(t)}
          </Row>
        </Button>
      }
    />
  );
}
